export default __webpack_public_path__ + "static/media/ellipsis-vertical-icon.b882a5cb.svg";